"use strict";
var core_1 = require('@angular/core');
var octave_ts_1 = require('./octave.ts');
var Keyboard = (function () {
    function Keyboard() {
        var _this = this;
        this.constructHandlers = function (octaves) {
            var that = _this;
            return octaves.map(function (octave) {
                return function (noteIndex) {
                    that.playMidiNote(octave * 12 + noteIndex);
                };
            });
        };
        this.topOctaveHandlers = this.constructHandlers([6, 7, 8, 9, 10]);
        this.bottomOctaveHandlers = this.constructHandlers([0, 1, 2, 3, 4, 5]);
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], Keyboard.prototype, "playMidiNote", void 0);
    Keyboard = __decorate([
        core_1.Component({
            selector: 'keyboard',
            template: "\n    <div style=\"height:120px;position:absolute;left:0;bottom:125px;width:100%;\n      text-align:center;left:10.42%;width:79.16%;\">\n      <div *ngFor=\"let pressHandler of topOctaveHandlers; let i = index\"\n        style=\"width:20%;height:100%;float:left;\">\n        <octave [handlePress]=\"pressHandler\"></octave>\n      </div>\n    </div>\n    <div style=\"height:120px;position:absolute;left:2.5%;bottom:5px;width:95%;\n      text-align:center;\">\n      <div *ngFor=\"let pressHandler of bottomOctaveHandlers; let i = index\"\n        style=\"width:16.66%;height:100%;float:left;\">\n        <octave style=\"height:100%;width:100%;\"\n          [handlePress]=\"pressHandler\"></octave>\n      </div>\n    </div>\n  ",
            directives: [octave_ts_1.Octave],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }), 
        __metadata('design:paramtypes', [])
    ], Keyboard);
    return Keyboard;
}());
exports.Keyboard = Keyboard;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5Ym9hcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJrZXlib2FyZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBSU8sZUFBZSxDQUFDLENBQUE7QUFFdkIsMEJBQXVCLGFBQWEsQ0FBQyxDQUFBO0FBMEJyQztJQWtCRTtRQWxCRixpQkFtQkM7UUFoQlMsc0JBQWlCLEdBQUcsVUFBQyxPQUFzQjtZQUNqRCxJQUFNLElBQUksR0FBRyxLQUFJLENBQUM7WUFDbEIsTUFBTSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBQyxNQUFjO2dCQUNoQyxNQUFNLENBQUMsVUFBQyxTQUFpQjtvQkFDdkIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEdBQUcsRUFBRSxHQUFHLFNBQVMsQ0FBQyxDQUFDO2dCQUM3QyxDQUFDLENBQUM7WUFDSixDQUFDLENBQUMsQ0FBQztRQUNMLENBQUMsQ0FBQztRQUVNLHNCQUFpQixHQUNuQixJQUFJLENBQUMsaUJBQWlCLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUV2Qyx5QkFBb0IsR0FDdEIsSUFBSSxDQUFDLGlCQUFpQixDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBRWxDLENBQUM7SUFqQmhCO1FBQUMsWUFBSyxFQUFFOztrREFBQTtJQXhCVjtRQUFDLGdCQUFTLENBQUM7WUFDVCxRQUFRLEVBQUUsVUFBVTtZQUNwQixRQUFRLEVBQUUsMHRCQWdCVDtZQUNELFVBQVUsRUFBRSxDQUFDLGtCQUFNLENBQUM7WUFDcEIsZUFBZSxFQUFFLDhCQUF1QixDQUFDLE1BQU07U0FDaEQsQ0FBQzs7Z0JBQUE7SUFxQkYsZUFBQztBQUFELENBQUMsQUFuQkQsSUFtQkM7QUFuQlksZ0JBQVEsV0FtQnBCLENBQUE7QUFBQSxDQUFDIn0=


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/keyboard/keyboard.ts
 ** module id = 961
 ** module chunks = 1
 **/